import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
import ConfigurationSummaryConfirmationCardTypeEnum from '../../enums/ConfigurationSummaryConfirmationCardTypeEnum.js';
/**
 * Styles.
 */
export default class ConfigurationSummaryConfirmationCardStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @param options.hasScreenshot ...
     * @param options.type ...
     * @returns CSS for ConfigurationSummary.
     */
    static getStyle(options) {
        const { color, spacing } = options.theme;
        return css `
			${Text.CSS}

			.heading {
				margin-top: 0;
				margin-bottom: ${spacing.space150 / 16}rem;
			}

			.productInformation {
				display: flex;
				${options.hasScreenshot ? 'gap:' + spacing.space100 / 16 + 'rem' : ''};
			}

			.productInformation kompis-image {
				height: ${96 / 16}rem;
				width: auto;
			}

			.errorMessageProductInformation {
				color: ${color.text.default};
			}

			.addToBag {
				display: flex;
				align-items: flex-start;
			}

			.message {
				margin-bottom: ${spacing.space50 / 16}rem;
			}

			.vpcArea {
				display: flex;
				flex-direction: column;
			}

			kompis-copy-design-code {
				margin-bottom: ${spacing.space100 / 16}rem;
			}

			.goToLink {
				margin-top: ${spacing.space150 / 16}rem;
			}

			.content {
				display: flex;
				flex-direction: column;
				color: ${color.text.dark};
			}

			.informationMessage {
				margin-top: ${spacing.space150 / 16}rem;
			}

			.errorMessage {
				margin-top: ${options.type !== ConfigurationSummaryConfirmationCardTypeEnum.saveVpcFail
            ? spacing.space150 / 16
            : '0'}rem;
			}

			.line {
				height: ${1 / 16}rem;
				flex-shrink: 0;
				background-color: ${color.neutral.grey200};
				margin: ${spacing.space250 / 16}rem 0;
			}

			.divider {
				height: ${spacing.space150 / 16}rem;
			}

			/* Disable user agent styling for anchor tag */
			a {
				padding: 0;
				border: 0;
			}

			.saveDesignAreaAndLinkCardContainer {
				display: flex;
				flex-direction: column;
				gap: ${spacing.space250 / 16}rem;
			}

			.saveDesignContainer {
				display: flex;
				flex-direction: column;
				gap: ${spacing.space150 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=ConfigurationSummaryConfirmationCardStyle.js.map